import { StateCreator } from 'zustand'

interface PerformanceMetric {
    timestamp: number
    type: 'navigation' | 'api' | 'render'
    duration: number
    details: Record<string, any>
}

export interface PerformanceSlice {
    metrics: PerformanceMetric[]
    addMetric: (metric: Omit<PerformanceMetric, 'timestamp'>) => void
    getAverageLoadTime: (type: PerformanceMetric['type']) => number
    getSlowestOperations: (limit?: number) => PerformanceMetric[]
}

export const createPerformanceSlice: StateCreator<PerformanceSlice> = (
    set,
    get
) => ({
    metrics: [],
    addMetric: (metric) => {
        set((state) => ({
            metrics: [
                { ...metric, timestamp: Date.now() },
                ...state.metrics
            ].slice(0, 1000)
        }))
    },
    getAverageLoadTime: (type) => {
        const metrics = get().metrics.filter((m) => m.type === type)

        return metrics.reduce((acc, m) => acc + m.duration, 0) / metrics.length
    },
    getSlowestOperations: (limit = 5) => {
        return [...get().metrics]
            .sort((a, b) => b.duration - a.duration)
            .slice(0, limit)
    }
})
